<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Judges
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To teach that even as Christians we will keep making mistakes and fail to love God as we should.
                        </li>
                        <li>
                            To teach that God faithfully saves those who repent of sin and helps them to live for him.
                        </li>
                        <li>
                            To teach that God uses us to carry out his plans despite our weakness, pride and failures.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series consists of four lessons, including an introduction to the
                        cycle of rebellion in the book of Judges.
                        Each lesson focuses on one judge as a case study, highlighting two key themes:
                    </p>

                    <ul>
                        <li>
                            Man's Failures – Both the judges whom God raised up to rescue
                            Israel and the people themselves failed to trust and live for God
                            (weeks 2, 3 and 4). Even those who did love God were weak and could
                            not bring about lasting change or repentance (week 1).
                        </li>
                        <li>
                            God's Faithfulness – Despite Israel's constant failures and
                            rebellion against him, God remained faithful to his people.
                            He sent foreign armies to oppress them in order to lead them to repentance
                            (weeks 1, 2 and 4); he rescued them whenever they cried out to him (weeks 1 and 2);
                            and he even saved them when they did not ask for help or give him the glory he
                            deserved (weeks 3 and 4).
                        </li>
                    </ul>

                    <p>
                        Throughout the book of Judges God is clearly seen as the true hero
                        of the story as he patiently disciplines and rescues his people.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - Ehud the Unlikely (Judges 2:6-3:6, 3:12-30)
                    </p>
                    <p>
                        Lesson 2 - Gideon the Small (Judges 6:1-7:25)
                    </p>
                    <p>
                        Lesson 3 - Gideon the Great (Judges 8:1-35)
                    </p>
                    <p>
                        Lesson 4 - Samson the Sinner (Judges 13:1-7; 14:1-9; 15:20-16:30)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Judges",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Judges`,
            meta: [
                {
                    name: 'description',
                    content: "To teach that even as Christians we will keep making mistakes and fail to love God as we should.",
                },
            ],
        };
    },
};
</script>
